<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page" *ngIf="!contentReady">
  <div class="bb-page-shell">

    <!-- Header -->
    <div class="bb-page-header">
      <div class="bb-page-title-block">
        <span class="bb-eyebrow">{{ "all services" | transloco }}</span>
        <h2 class="bb-page-title">{{ "all services" | transloco }}</h2>
        <p class="bb-page-subtitle">{{ "manage services" | transloco }}</p>
      </div>

      <div class="bb-header-actions">
        @if (!isStockTaking) {
          @if (isAdmin || isSubAdmin) {
            <button routerLink="/AddService" class="bb-btn bb-btn-primary bb-btn-wide">
              {{ "add service" | transloco }}
            </button>
          }
        }
      </div>
    </div>

    <!-- Search Card -->
    <div class="bb-filter-card">
      <div class="search-row">
        <div class="search-box">
          <input
            type="text"
            class="bb-input form-control"
            [(ngModel)]="searchKey"
            placeholder="{{ 'service name' | transloco }}"
            (keydown.enter)="onEnterPressed()"
          />

          <button class="bb-btn bb-btn-primary" (click)="search()">
            {{ "Search" | transloco }}
          </button>

          <button *ngIf="searched" class="bb-btn bb-btn-secondary" (click)="clearSearch()" type="button">
            {{ "all data" | transloco }}
          </button>
        </div>
      </div>

      @if (cartItemCount > 0) {
        <div *ngIf="!noData" class="bb-floating-cart floating-cart" (click)="cartPopUpOpen()">
          <span class="bb-floating-cart-count count">{{ cartItemCount }}</span>
          <i class="fa-solid fa-cart-shopping"></i>
          {{ "Cart" | transloco }}
        </div>
      }
    </div>

    <!-- Table -->
    <div class="bb-table-card bb-p-16" *ngIf="!noData">
      <div class="bb-table-scroll stock-table-wrapper">
        <table mat-table id="stocktable" [dataSource]="dataSource" class="bb-table table-custom mat-elevation-z0">

          <!-- Name EN Column -->
          <ng-container matColumnDef="name_en">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom">
              {{ "Name" | transloco }}
            </th>

            <td mat-cell *matCellDef="let element" class="mat-cell-custom">
              <div class="bb-inline-flex bb-items-center bb-gap-12">
                @if (element.image != null) {
                  <div class="bb-product-img-box">
                    <img [src]="fixImage(element.image)" />
                  </div>
                }

                <div class="bb-text-stack">
                  <strong class="bb-product-title">{{ element.name_en }}</strong>
                  <small>{{ element.barcode }}</small>
                </div>
              </div>
            </td>
          </ng-container>

          <!-- Name AR Column -->
          <ng-container matColumnDef="name_ar">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom">
              {{ "NameAr" | transloco }}
            </th>

            <td mat-cell *matCellDef="let element" class="mat-cell-custom">
              <div class="bb-inline-flex bb-items-center bb-gap-12">
                @if (element.image != null) {
                  <div class="bb-product-img-box">
                    <img [src]="fixImage(element.image)" />
                  </div>
                }

                <div class="bb-text-stack">
                  <strong class="bb-product-title">{{ element.name_ar }}</strong>
                  <small>{{ element.barcode }}</small>
                </div>
              </div>
            </td>
          </ng-container>

          <!-- Pet Type Column -->
          <ng-container matColumnDef="pet_type">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom">
              {{ "pet type" | transloco }}
            </th>

            <td mat-cell *matCellDef="let element" class="mat-cell-custom">
              <ng-container [ngSwitch]="element.pet_type">
                <span *ngSwitchCase="'0'" class="bb-badge bb-badge-soft-blue">{{ "adult" | transloco }}</span>
                <span *ngSwitchCase="'1'" class="bb-badge bb-badge-soft-cyan">{{ "kitten" | transloco }}</span>
                <span *ngSwitchCase="'2'" class="bb-badge bb-badge-success">{{ "sterilized" | transloco }}</span>
                <span *ngSwitchCase="'3'" class="bb-badge bb-badge-soft-blue">{{ "persian" | transloco }}</span>
                <span *ngSwitchCase="'4'" class="bb-badge bb-badge-warning">{{ "puppy" | transloco }}</span>
                <span *ngSwitchCase="'5'" class="bb-badge bb-badge-soft-cyan">{{ "birds" | transloco }}</span>
                <span *ngSwitchCase="'6'" class="bb-badge bb-badge-soft-blue">{{ "other" | transloco }}</span>
                <span *ngSwitchDefault class="bb-text-muted">-</span>
              </ng-container>
            </td>
          </ng-container>

          <!-- Pet Column -->
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom">
              {{ "pet" | transloco }}
            </th>

            <td mat-cell *matCellDef="let element" class="mat-cell-custom">
              <ng-container [ngSwitch]="element.pet">
                <span *ngSwitchCase="'0'" class="bb-badge pet-type-badge cats">{{ "cats" | transloco }}</span>
                <span *ngSwitchCase="'1'" class="bb-badge pet-type-badge dogs">{{ "dogs" | transloco }}</span>
                <span *ngSwitchCase="'2'" class="bb-badge pet-type-badge birds">{{ "birds" | transloco }}</span>
                <span *ngSwitchCase="'4'" class="bb-badge pet-type-badge cats-dogs">{{ "cats&dogs" | transloco }}</span>
                <span *ngSwitchCase="'3'" class="bb-badge pet-type-badge other">{{ "other" | transloco }}</span>
                <span *ngSwitchDefault class="bb-text-muted">-</span>
              </ng-container>
            </td>
          </ng-container>

          <!-- Price -->
          <ng-container matColumnDef="price">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom">
              {{ "Cost price" | transloco }}
            </th>

            <td mat-cell *matCellDef="let element" class="mat-cell-custom">
              <strong class="bb-price">{{ element.price }}</strong>
            </td>
          </ng-container>

          <!-- Selling Price -->
          <ng-container matColumnDef="pricea">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom">
              {{ "Selling price" | transloco }}
            </th>

            <td mat-cell *matCellDef="let element" class="mat-cell-custom">
              <strong class="bb-price">{{ element.pricea }}</strong>
            </td>
          </ng-container>

          <!-- Actions -->
          <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom bb-actions-th">
            </th>

            <td mat-cell *matCellDef="let element" class="mat-cell-custom bb-actions-td">
              @if (isSubAdmin) {
                <button
                  class="bb-icon-btn action-btn cart"
                  type="button"
                  [class.active]="isInCart(element)"
                  (click)="addToCart(element)"
                  [title]="isInCart(element) ? ('remove from cart' | transloco) : ('add or remove from cart' | transloco)"
                >
                  <i
                    class="fa-solid"
                    [class.fa-cart-plus]="!isInCart(element)"
                    [class.fa-trash-can]="isInCart(element)"
                  ></i>
                </button>
              } @else {
              <div class="bb-action-dropdown dropdown">
                <button
                  class="bb-icon-btn action-btn menu"
                  type="button"
                  data-bs-toggle="dropdown"
                  data-bs-boundary="viewport"
                  aria-expanded="false"
                  title="{{ 'Actions' | transloco }}"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <circle cx="12" cy="5" r="2" />
                    <circle cx="12" cy="12" r="2" />
                    <circle cx="12" cy="19" r="2" />
                  </svg>
                </button>

                <ul class="bb-dropdown-menu dropdown-menu dropdown-menu-end">
                  <li>
                    <a class="bb-dropdown-item dropdown-item" (click)="addToCart(element)">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <circle cx="9" cy="21" r="1" />
                        <circle cx="20" cy="21" r="1" />
                        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
                      </svg>
                      {{ "add or remove from cart" | transloco }}
                    </a>
                  </li>

                  @if (isSubAdmin || isSuperAdmin || isAdmin) {
                    @if (!isSubAdmin) {
                      <li>
                        <a class="bb-dropdown-item dropdown-item" (click)="edit(element)">
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                          </svg>
                          {{ "Edit" | transloco }}
                        </a>
                      </li>

                      <li>
                        <hr class="dropdown-divider">
                      </li>

                      <li>
                        <a class="bb-dropdown-item dropdown-item text-danger" (click)="deleteitem(element.id)">
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" />
                          </svg>
                          {{ "Delete" | transloco }}
                        </a>
                      </li>
                    }
                  }
                </ul>
              </div>
              }
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns" class="mat-header-row-custom"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="mat-row-custom"></tr>
        </table>
      </div>

      <mat-paginator
        *ngIf="totalItems > 0"
        class="bb-paginator"
        [length]="totalItems"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex - 1"
        showFirstLastButtons
        (page)="onPaginateChange($event)"
      >
      </mat-paginator>
    </div>

    <!-- No Data State -->
    <div *ngIf="noData" class="bb-empty-state">
      <app-nodata></app-nodata>
    </div>

  </div>
</section>

<!-- Cart Popup -->
<div *ngIf="cartPopUp" class="bb-modal-backdrop popup">
  <div class="bb-modal-card bb-modal-sm popup-content">
    <div class="bb-modal-header">
      <h4>{{ "Cart" | transloco }}</h4>

      <button class="bb-modal-close" (click)="close()" type="button">
        ×
      </button>
    </div>

    <div class="bb-cart-list cart-cont">
      <div *ngFor="let item of cartItems" class="bb-cart-item cart-item">
        <span>
          {{ isAr ? item.name_ar : item.name_en }}
          ({{ item.cartItemType === 'service' || (!item.cartItemType && item.quantity === undefined) ? 'خدمة' : 'منتج' }})
        </span>

        <span class="bb-icon-btn bb-icon-btn-danger" (click)="removeFromCart(item)" type="button">
          <i class="fa-solid fa-trash"></i>
        </span>
      </div>
    </div>

    <div class="bb-modal-actions">
      <button class="bb-btn bb-btn-primary" (click)="quickOrder()">
        {{ "proceed to add order" | transloco }}
      </button>

      <button (click)="close()" class="bb-btn bb-btn-secondary" type="button">
        {{ "close" | transloco }}
      </button>
    </div>
  </div>
</div>
